module.exports = __webpack_public_path__ + "static/media/5.d383bc27.png";